module.exports = __webpack_public_path__ + "static/media/stories.f4d2d18a.svg";